import { Navigate, Outlet } from "react-router-dom";
import useLoginStore from "../../stores/loginStore";

/**
 * 인증된 사용자만 접근할 수 있는 라우트를 위한 컴포넌트
 * 인증되지 않은 사용자는 로그인 페이지로 리다이렉트됩니다.
 */
const ProtectedRoute = () => {
  const { isAuthenticated } = useLoginStore();

  // 인증되지 않은 경우 로그인 페이지로 리다이렉트
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // 인증된 경우 자식 라우트 렌더링
  return <Outlet />;
};

export default ProtectedRoute;
